var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chip-def mt-0 mb-0",on:{"click":function($event){return _vm.goSearchResults(_vm.item.id)}}},[_c('a',{staticClass:"text-ellipsis"},[_vm._v(" "+_vm._s(_vm.htmlDecode(_vm.item.name))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }